<template>
  <div class="exinfo">
    <!-- 组织架构 -->
    <div class="exinfo-li">
      <h2>
        <i></i>
        <span>组织架构</span>
      </h2>
      <div class="exinfo-main" v-if="OrganList.length">
        <div class="group-list" v-for="(item, index) in OrganList" :key="index">
          <!-- <h3>{{item.Name}}</h3>
          <span v-for="(item,index) in item.child" :key="index" v-html="$service.replaceSpeace(item.Value)"></span>-->
          <h3>{{ item.title }}</h3>
          <span class="van-ellipsis" v-for="(cItem, index) in item.conList" :key="index">{{ cItem }}</span>
        </div>
      </div>
      <div class="exinfo-main" v-else>
        <p class="no-msg">暂无数据！</p>
      </div>
    </div>
    <!-- 展会简介 -->
    <div class="exinfo-li">
      <h2>
        <i></i>
        <span>展会简介</span>
      </h2>
      <div class="exinfo-msg">
        <div style="position:relative;">
          <p class="des" :style="{ height: part }" ref="desP" v-html="$service.replaceSpeace(remark)"></p>
          <div v-if="desFlag" class="mask"></div>
        </div>
        <p v-if="desFlag" @click="allP()">
          展开全部
          <i></i>
        </p>
      </div>
      <!-- <div class="exinfo-main" v-else>
                <p class="no-msg">暂无简介！</p>
      </div>-->
    </div>
    <!-- 上届回顾 -->
    <div class="exinfo-li" v-if="false">
      <h2>
        <i></i>
        <span>上届回顾</span>
      </h2>
      <div class="exinfo-last" v-if="Banner.length">
        <div class="bg-img">
          <!-- <img :src="selectImg"  v-if="selectImg"  v-load="'ex_general_big'">  -->
          <img src="https://img.zhanshangxiu.com/showonline/file/202007/152f9a71571d460ab3bf8671d4e6d353.jpg" alt />
        </div>
        <div class="img-list">
          <card :banner="Banner" @UpImg="UpImg" v-load="'ex_general'"></card>
        </div>
      </div>
      <div class="exinfo-last" v-else>
        <p class="no-msg">暂无数据！</p>
      </div>
    </div>
  </div>
</template>
<script>
import card from "./swiperCard.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "exinfo",
  data() {
    return {
      OrganList: [], //组织架构
      part: "",
      desFlag: false,
      Banner: [1, 1, 1, 1, 1, 1, 1],
      selectImg: "",
    };
  },
  components: { card },
  computed: {
    ...mapGetters({
      exhibitionInfo: "getExhibitionInfo",
      userInfo: "getUserInfo",
    }),
    exhibitionId() {
      return this.$route.params.id;
    },
    remark() {
      return this.exhibitionInfo.exhibition.remark;
    },
  },
  async created() {
    if (!this.userInfo) {
      this.$store.commit("setExhibitionId", this.exhibitionId);
      await this.$Myapollo.getUserInfo(this);
    }
    await this.$Myapollo.getExhibitionInfo(this, this.exhibitionId, this.userInfo.userId);
    this.getOrganList();
    // document.title = this.$t("Headline.exinfo");
    // this.init();
  },
  mounted() {
    this.$nextTick(function() {
      if (this.$refs.desP && this.$refs.desP.offsetHeight > 135) {
        // this.part = '135px';
        // this.desFlag = true;
      }
    });
  },
  methods: {
    getOrganList() {
      console.log(this.exhibitionInfo.exhibition, "展会信息");
      let organ = this.exhibitionInfo.exhibition.organization;
      let arr = [];
      if (organ && organ.indexOf("[") != -1) {
        arr = JSON.parse(organ);
        console.log(arr, "arr");
        arr.forEach((e) => {
          e.conList = e.content.split("\n");
        });
      }
      this.OrganList = arr;
      console.log(this.OrganList, "1");
    },
    init() {
      this.getOrganization();
      this.getBanner();
    },
    getOrganization() {
      this.$http.get("/api/organization?exhibitionid=" + this.exhibitionId, this.$service.v2ApiHeader).then((res) => {
        if (res.status === 200 && res.data) {
          var OrganList = res.data;
          let dataInfo = {};
          OrganList.forEach((item) => {
            let { Name } = item;
            if (!dataInfo[Name]) {
              dataInfo[Name] = {
                Name,
                child: [],
              };
            }
            dataInfo[Name].child.push(item);
          });
          let list = Object.values(dataInfo); // list 转换成功的数据
          this.OrganList = list;
        }
      });
    },
    getBanner() {
      const reqBody = {
        By: this.exhibitionId,
        Order: "asc",
        condition: [
          { With: "and", Label: "BannerType", Type: "equal", Value: 10 },
          { With: "and", Label: "IsShow", Type: "equal", Value: true },
        ],
        PageSize: 20,
        PageIndex: 1,
      };
      this.$http
        .post("/api/exhibitionbanner/wherepage", reqBody, {
          headers: { "api-version": 2 },
        })
        .then(({ data: { StatusCode, Data } }) => {
          if (StatusCode === 200 && Data) {
            this.Banner = Data.List;
            this.selectImg = this.Banner[0] ? this.Banner[0].ImgUrl : "";
          }
        });
    },
    allP() {
      this.$nextTick(function() {
        this.desFlag = false;
        this.part = "auto";
      });
    },
    UpImg(img) {
      this.selectImg = img;
    },
  },
};
</script>
<style lang="scss" scoped>
.exinfo {
  &-li {
    background: #fff;
    border-top: 10px solid #f5f5f5;
    h2 {
      padding: 15px;
      font-size: 15px;
      color: #333;
      font-weight: 600;
      display: flex;
      align-items: center;
      line-height: 1.2;
      i {
        width: 3px;
        height: 16px;
        background-color: #1890ff;
        margin-right: 5px;
        display: inline-block;
      }
    }
  }
  &-main {
    padding: 0 23px 15px;
    .group-list {
      margin-bottom: 10px;
      h3 {
        font-size: 15px;
        font-weight: bold;
        line-height: 24px;
        color: #333;
      }
      span {
        font-size: 13px;
        line-height: 20px;
        color: #333;
        display: block;
      }
    }
    .group-list:last-child {
      margin-bottom: 0;
    }
  }
  &-msg {
    padding: 0 15px 15px;
  }
  &-last {
    padding: 0 15px 15px;
    .bg-img {
      width: 100%;
      padding-top: 60%;
      position: relative;
      margin-bottom: 10px;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
}
.no-msg {
  padding: 30px 0;
  text-align: center;
  color: #777;
  font-size: 12px;
}
.mask {
  background-image: linear-gradient(0deg, #fff 0%, rgba(255, 255, 255, 0.85) 58%, rgba(255, 255, 255, 0.7) 100%);
  width: 100%;
  height: 24px;
  position: absolute;
  bottom: -5px;
  left: 0;
}
p {
  width: 80px;
  text-align: center;
  margin: 10px auto 0;
  color: #4d4d4d;
  i {
    border-left: 1px solid #4c4c4c;
    border-bottom: 1px solid #4c4c4c;
    height: 8px;
    width: 8px;
    transform: translate(2px, -2px) rotate(-45deg);
    -webkit-transform: translate(2px, -2px) rotate(-45deg);
    border-right: 1px solid transparent;
    border-top: 1px solid transparent;
    display: inline-block;
    -moz-transform: translate(2px, -2px) rotate(-45deg);
    -ms-transform: translate(2px, -2px) rotate(-45deg);
    -o-transform: translate(2px, -2px) rotate(-45deg);
    margin-left: 5px;
  }
}
.des {
  width: 100%;
  font-size: 13px;
  line-height: 24px;
  text-align: left;
  margin: 0;
  color: #333;
  overflow: hidden;
}
</style>
